import { render } from "./supports.vue?vue&type=template&id=358cdd8d"
import script from "./supports.vue?vue&type=script&lang=js"
export * from "./supports.vue?vue&type=script&lang=js"

import "./supports.vue?vue&type=style&index=0&id=358cdd8d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__